module.exports = __webpack_public_path__ + "img/tab_icon6.77e24637.png";